import React from 'react';
import { Bell, GitBranch, Radio } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#007acc] text-white text-xs font-mono py-1 px-4 border-t border-[#005f9e]">
      <div className="flex flex-col md:flex-row justify-between items-center gap-2">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 hover:bg-white/10 px-2 py-1 rounded cursor-pointer transition-colors">
            <GitBranch size={12} />
            <span>master*</span>
          </div>
          <div className="flex items-center gap-1 hover:bg-white/10 px-2 py-1 rounded cursor-pointer transition-colors">
            <Radio size={12} />
            <span>Live Share</span>
          </div>
          <div className="hidden md:flex items-center gap-1">
            <span>0 errors</span>
            <span>0 warnings</span>
          </div>
        </div>

        <div className="flex gap-6 opacity-80">
          <a href="/privacy" className="hover:text-white hover:underline decoration-1 underline-offset-2">
            src/privacy.md
          </a>
          <a href="/terms" className="hover:text-white hover:underline decoration-1 underline-offset-2">
            src/terms.md
          </a>
          <a href="#contact" className="hover:text-white hover:underline decoration-1 underline-offset-2">
            @ayum_dev
          </a>
        </div>

        <div className="flex items-center gap-4">
          <span className="hidden md:inline">Ln 2024, Col 1</span>
          <span className="hidden md:inline">UTF-8</span>
          <div className="flex items-center gap-2">
            <Bell size={12} />
            <span>Notifications</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
